"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceChangedStatus = exports.FN = void 0;
var sdk_core_1 = require("@acala-network/sdk-core");
Object.defineProperty(exports, "FN", { enumerable: true, get: function () { return sdk_core_1.FixedPointNumber; } });
var BalanceChangedStatus;
(function (BalanceChangedStatus) {
    BalanceChangedStatus[BalanceChangedStatus["CHECKING"] = 0] = "CHECKING";
    BalanceChangedStatus[BalanceChangedStatus["SUCCESS"] = 1] = "SUCCESS";
    BalanceChangedStatus[BalanceChangedStatus["TIMEOUT"] = 2] = "TIMEOUT";
    BalanceChangedStatus[BalanceChangedStatus["UNKNOWN_ERROR"] = 3] = "UNKNOWN_ERROR";
})(BalanceChangedStatus = exports.BalanceChangedStatus || (exports.BalanceChangedStatus = {}));
